
{
  "familyId": "MET-GEW-OMREKEN",
  "questions": [
    {
      "id": "MET-GEW-OMREKEN-001",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel gram is 2 kilogram?",
      "context": null,
      "options": ["2.000 g", "200 g", "20 g", "20.000 g"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "stairs", "data": {"type": "weight", "from": "kg", "to": "g"}}],
      "supportAids": [{"type": "stairs", "showWhen": "wrong", "data": {"type": "weight", "from": "kg", "to": "g", "value": 2, "highlight": true}}],
      "conceptId": "weight_kg_to_g",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Van kilogram naar gram ga je 1 trede naar beneden op het trapje: ×1.000. Dus: 2 kg = 2 × 1.000 = 2.000 g.",
        "distractorExplanations": {
          "0": "Correct! 2 kg × 1.000 = 2.000 g.",
          "1": "Fout: je hebt door 10 gedeeld in plaats van met 1.000 vermenigvuldigd. Van kg naar g is ×1.000: 2 × 1.000 = 2.000 g.",
          "2": "Fout: je hebt te weinig vermenigvuldigd. Van kg naar g is ×1.000: 2 × 1.000 = 2.000 g, niet 2 × 10 = 20 g.",
          "3": "Fout: je hebt met 10.000 vermenigvuldigd in plaats van 1.000. Van kg naar g is ×1.000: 2 × 1.000 = 2.000 g."
        }
      }
    },
    {
      "id": "MET-GEW-OMREKEN-002",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel kilogram is 5.000 gram?",
      "context": null,
      "options": ["5 kg", "50 kg", "0,5 kg", "500 kg"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "stairs", "data": {"type": "weight", "from": "g", "to": "kg"}}],
      "supportAids": [{"type": "stairs", "showWhen": "wrong", "data": {"type": "weight", "from": "g", "to": "kg", "value": 5000, "highlight": true}}],
      "conceptId": "weight_g_to_kg",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Van gram naar kilogram ga je 1 trede omhoog op het trapje: ÷1.000. Dus: 5.000 g = 5.000 ÷ 1.000 = 5 kg.",
        "distractorExplanations": {
          "0": "Correct! 5.000 g ÷ 1.000 = 5 kg.",
          "1": "Fout: je hebt door 100 gedeeld in plaats van door 1.000. Van g naar kg is ÷1.000: 5.000 ÷ 1.000 = 5 kg.",
          "2": "Fout: je hebt door 10.000 gedeeld in plaats van door 1.000. Van g naar kg is ÷1.000: 5.000 ÷ 1.000 = 5 kg.",
          "3": "Fout: je hebt door 10 gedeeld in plaats van door 1.000. Van g naar kg is ÷1.000: 5.000 ÷ 1.000 = 5 kg."
        }
      }
    },
    {
      "id": "MET-GEW-OMREKEN-003",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel gram is 1,5 kilogram?",
      "context": null,
      "options": ["1.500 g", "150 g", "15 g", "15.000 g"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "stairs", "data": {"type": "weight", "from": "kg", "to": "g"}}],
      "supportAids": [{"type": "stairs", "showWhen": "wrong", "data": {"type": "weight", "from": "kg", "to": "g", "value": 1.5, "highlight": true}}],
      "conceptId": "weight_kg_to_g_decimal",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Van kg naar g is ×1.000. Dus: 1,5 kg = 1,5 × 1.000 = 1.500 g. Tip: 1 kg = 1.000 g, plus 0,5 kg = 500 g → totaal 1.500 g.",
        "distractorExplanations": {
          "0": "Correct! 1,5 × 1.000 = 1.500 g.",
          "1": "Fout: je hebt met 100 vermenigvuldigd in plaats van 1.000. Van kg naar g is ×1.000: 1,5 × 1.000 = 1.500 g.",
          "2": "Fout: je hebt met 10 vermenigvuldigd in plaats van 1.000. Van kg naar g is ×1.000: 1,5 × 1.000 = 1.500 g.",
          "3": "Fout: je hebt met 10.000 vermenigvuldigd in plaats van 1.000. Van kg naar g is ×1.000: 1,5 × 1.000 = 1.500 g."
        }
      }
    },
    {
      "id": "MET-GEW-OMREKEN-004",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een zak aardappelen weegt 3 kg. Hoeveel gram is dat?",
      "context": null,
      "options": ["3.000 g", "300 g", "30 g", "30.000 g"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "stairs", "showWhen": "wrong", "data": {"type": "weight", "from": "kg", "to": "g", "value": 3, "highlight": true}}],
      "conceptId": "weight_kg_to_g_context",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Van kilogram naar gram: ×1.000. Dus: 3 kg = 3 × 1.000 = 3.000 g. Een zak aardappelen van 3 kg weegt 3.000 gram.",
        "distractorExplanations": {
          "0": "Correct! 3 kg = 3 × 1.000 = 3.000 g.",
          "1": "Fout: je hebt met 100 vermenigvuldigd. Van kg naar g is ×1.000: 3 × 1.000 = 3.000 g.",
          "2": "Fout: je hebt met 10 vermenigvuldigd. Van kg naar g is ×1.000: 3 × 1.000 = 3.000 g.",
          "3": "Fout: je hebt met 10.000 vermenigvuldigd. Van kg naar g is ×1.000: 3 × 1.000 = 3.000 g."
        }
      }
    },
    {
      "id": "MET-GEW-OMREKEN-005",
      "familyId": "MET-GEW-OMREKEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_omrekenen",
      "questionType": "multiple_choice",
      "question": "750 gram is evenveel als ... kilogram.",
      "context": null,
      "options": ["0,75 kg", "7,5 kg", "75 kg", "0,075 kg"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "stairs", "showWhen": "wrong", "data": {"type": "weight", "from": "g", "to": "kg", "value": 750, "highlight": true}}],
      "conceptId": "weight_g_to_kg_decimal",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Van gram naar kilogram: ÷1.000. Dus: 750 g = 750 ÷ 1.000 = 0,75 kg. Tip: 1.000 g = 1 kg, dus 750 g = 750/1.000 kg = 0,75 kg.",
        "distractorExplanations": {
          "0": "Correct! 750 g ÷ 1.000 = 0,75 kg.",
          "1": "Fout: je hebt door 100 gedeeld in plaats van door 1.000. Van g naar kg is ÷1.000: 750 ÷ 1.000 = 0,75 kg.",
          "2": "Fout: je hebt door 10 gedeeld in plaats van door 1.000. Van g naar kg is ÷1.000: 750 ÷ 1.000 = 0,75 kg.",
          "3": "Fout: je hebt door 10.000 gedeeld in plaats van door 1.000. Van g naar kg is ÷1.000: 750 ÷ 1.000 = 0,75 kg."
        }
      }
    }
  ]
}
